import { MixAndMatchBaseCoupon } from "./mix-and-match-base";
import { FirstMatchGroupItemTriggerItemsQualifier } from "../../coupon-qualifiers/trigger-items/first-match-group-item-trigger-items";
import { BeforeTaxDistributor } from "../../../services/discount-distributors/before-tax-distributor";
import { QuantityDiscountAllocator } from "../../../services/discount-distributors/allocators/quantity-discount-allocator";
/**
 * QUANTITY_DISCOUNT (coupon type 51).
 *
 * Modeled on AOLO3 (`coupons.ts`). Unlike QUANTITY_PRICE / MIX_AND_MATCH_PRICE — which drive the
 * qualified items down *to* a target price — this type takes a flat dollar amount *off* each
 * qualifying item's price (`_getDiscountAmountForQuantityDiscountCoupon`), and gets its own
 * before-tax split branch in `_splitDiscountBeforeTax`.
 *
 * Qualification matches QUANTITY_PRICE: `_getQualifiedItemList` has no case for type 51, so it falls
 * through to the generic `coupon.Items.length > 0` case — a single
 * `QualifyCouponItems(order, coupon, false, false, true)` pass with no mix-and-match sweep and no
 * minimum-quantity gate.
 */
export class QuantityDiscountCoupon extends MixAndMatchBaseCoupon {
    createTriggerItemsQualifier() {
        return new FirstMatchGroupItemTriggerItemsQualifier(this._data);
    }
    get enforcesMinimumQuantity() {
        return false;
    }
    getBeforeTaxDistributor() {
        return new BeforeTaxDistributor(new QuantityDiscountAllocator());
    }
    /**
     * Legacy `_getDiscountAmountForQuantityDiscountCoupon`: each qualifying item whose coupon price
     * beats its share of the discount contributes that share, then the coupon's total add-on price
     * (summed over *all* qualified items, not just the contributing ones) comes off the total.
     */
    computeDiscountAmount(items) {
        let discountAmount = 0;
        for (const item of items) {
            if (item.halfCount && item.cPrice > (this.discountValue / item.halfCount)) {
                discountAmount += (this.discountValue / item.halfCount);
            }
        }
        return discountAmount - this._getTotalCouponItemsPrices(items).couponAddOnPrice;
    }
    getConfiguredDiscountValueForDistribution() {
        // For QUANTITY_DISCOUNT this is the flat dollar amount to take off each qualifying item.
        return this.discountValue;
    }
}
//# sourceMappingURL=quantity-discount.js.map